import React, { useEffect, useState } from "react";
import "./EventsDashboard.css";
import { Link, useLocation, useHistory } from "react-router-dom";
import { IoMdHourglass } from "react-icons/io";
import {
  BiCheckCircle,
  BiChevronLeft,
  BiGhost,
  BiMenu,
  BiMoney,
} from "react-icons/bi";
import Axios from "axios";
import { FcCancel } from "react-icons/fc";
import ReactTooltip from "react-tooltip";
import Header from "../../layouts/Header";
import SideNavCust from "../../layouts/SideNavCust";
import SideNav from "../../layouts/SideNav";
import ClipLoader from "react-spinners/ClipLoader";
import { IoCheckmarkCircleOutline, IoTicketOutline } from "react-icons/io5";

const url = "https://karamale.com/apps/kscanner/webservices.php";
const accounttype = localStorage.getItem("accounttype");

const SummaryCard = ({ title, count, icon }) => (
  <div className="summary-card">
    <div className="card-icon">{icon}</div>
    <div className="card-content">
      <h4>{title}</h4>
      <p>{count}</p>
    </div>
  </div>
);

function formatToZAR(amount) {
  const formatted = new Intl.NumberFormat("en-ZA", {
    style: "currency",
    currency: "ZAR",
  }).format(amount);
  return formatted.replace(/\s/g, "");
}

const EventRow = ({ transact, account_type, handleResend, resendingId }) => (
  <tr>
    <td data-tip={transact.transaction_id} data-place="right">
      ...{transact.transaction_id.slice(-6)}
      <ReactTooltip />
    </td>
    <td>{transact.date ?? transact.created_at}</td>
    <td data-tip={transact.event_name.trim()} data-place="right">
      {transact.event_name.length > 16
        ? transact.event_name.trim().slice(0, 16) + "..."
        : transact.event_name.trim()}
      <ReactTooltip />
    </td>
    <td className={account_type === "customer" ? "d-none" : ""}>
      {transact.name_first}
    </td>
    <td>{transact.ticket_type.toLowerCase()}</td>
    <td>{transact.admissions}</td>
    <td>{formatToZAR(transact.amount_gross) ?? 0.0}</td>
    <td>{transact.payment_status.toLowerCase()}</td>
    <td>
      {transact.refund_status !== null ? (
        <span
          className={`status-badge ${
            transact.refund_status === "pending"
              ? "upcoming"
              : transact.refund_status === "approved"
              ? "past"
              : "payout-badge unpaid"
          }`}
        >
          {transact.refund_status}
        </span>
      ) : (
        <span className="font-normal text-grey">None</span>
      )}
    </td>
    <td>{formatToZAR(transact.amount_refunded) ?? 0.0}</td>
    <td className={account_type !== "customer" ? "d-none" : ""}>
      <label
        data-tip={
          transact.ticket_resent_at != null
            ? "Ticket already resent at " + transact.ticket_resent_at
            : "Click to resend Ticket"
        }
        data-place={"top"}
        className={
          transact.payment_status.toLowerCase() !== "complete" ||
          transact.ticket_resent_at != null ||
          resendingId === transact.transaction_id ||
          transact.refund_status === "approved"
            ? "btn-disabled"
            : "action-btn"
        }
        onClick={() =>
          transact.payment_status.toLowerCase() !== "complete" ||
          transact.ticket_resent_at != null ||
          resendingId === transact.transaction_id ||
          transact.refund_status === "approved"
            ? ""
            : handleResend(transact.transaction_id)
        }
      >
        {resendingId === transact.transaction_id ? (
          <ClipLoader size={14} color="grey" />
        ) : (
          <>
            {transact.ticket_resent_at != null ? (
              <IoCheckmarkCircleOutline color={"#28a745"} />
            ) : (
              //   <IoTicketOutline />
              <></>
            )}{" "}
            {transact.ticket_resent_at != null ? "Resent" : "Resend"}
          </>
        )}
        <ReactTooltip />
      </label>
    </td>
  </tr>
);

const TransactionsCust = () => {
  const location = useLocation();
  const history = useHistory();
  const account_type = localStorage.getItem("accounttype");
  const queryParams = new URLSearchParams(location.search);
  const eventId = queryParams.get("q_id") || 0;

  const [statusFilter, setStatusFilter] = useState("ALL");
  const [sortBy, setSortBy] = useState("DATE_DESC");

  const [pendingTransact, setPendingTransact] = useState(0);
  const [completeTransact, setCompleteTransact] = useState(0);
  const [cancelledTransact, setCancelledTransact] = useState(0);
  const [abandonedTransact, setAbandonedTransact] = useState(0);
  const [refundedAmt, setRefundedAmt] = useState(0);
  const [transactionsList, setTransactionsList] = useState([]);
  const [loader, setLoader] = useState(true);
  const [resendStatus, setResendStatus] = useState(null); // 'success' | 'error' | null
  const [resendReponse, setResendReponse] = useState(null);
  const [resendingId, setResendingId] = useState(null); // holds transaction_id being processed
  const [count, setCount] = useState(0);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const isMobile = window.innerWidth <= 768;
  const [isMob, setIsMob] = useState(isMobile);
  const [collapsed, setCollapsed] = useState(isMobile);

  const updateIsMobile = () => {
    const mobile = window.innerWidth <= 768;
    setIsMob(mobile);
    setCollapsed((prev) => (mobile ? true : prev));
  };

  const handleResend = async (transaction_id) => {
    setResendingId(transaction_id); // mark as active
    const formData = new FormData();
    formData.append("transaction_id", transaction_id);
    formData.append("query", "RESEND-TICKET");

    try {
      const response = await Axios({
        url: url,
        method: "POST",
        data: formData,
        withCredentials: true,
      });

      const status = response.data?.status;
      const res = response.data;

      setResendReponse(res?.message);
      if (status === "success") {
        setResendStatus("success");
      } else {
        setResendStatus("error");
      }

      // Clear after 3 seconds
      //   setTimeout(() => setResendStatus(null), 3000);
    } catch (error) {
      console.log("Error occurred:", error);
      setResendStatus("error");
      //   setTimeout(() => setResendStatus(null), 3000);
    } finally {
      setCount(count + 1);
      setTimeout(() => {
        setResendStatus(null);
        setResendingId(null); // clear active state
      }, 3000);
    }
  };

  const fetchongoingEventsData = async () => {
    Axios.get(`${url}?query=TRANSACTION-AMOUNTS&event_id=${eventId}`, {
      withCredentials: true,
    })
      .then((response) => {
        setPendingTransact(response.data.pendingAmount);
        setCompleteTransact(response.data.completedAmount);
        setCancelledTransact(response.data.cancelledAmount);
        setAbandonedTransact(response.data.abandonedTransact);
        setRefundedAmt(response.data.refundedAmt);
      })
      .catch((error) => {
        console.error("Error fetching dashboard data:", error);
      });
  };

  const fetchTransactions = async () => {
    Axios.get(`${url}?query=TRANSACTIONS-LIST&event_id=${eventId}`, {
      withCredentials: true,
    })
      .then((response) => {
        setLoader(false);
        if (response.data.status === "success") {
          setTransactionsList(response.data.transactions);
        } else {
          setTransactionsList([]);
        }
      })
      .catch((error) => {
        setTransactionsList([]);
        console.error("Error fetching dashboard data:", error);
      });
  };

  useEffect(() => {
    fetchongoingEventsData();
    fetchTransactions();
    updateIsMobile();
    window.addEventListener("resize", updateIsMobile);
    return () => window.removeEventListener("resize", updateIsMobile);
  }, [eventId, count]);

  const handleToggle = () => setCollapsed((prev) => !prev);

  const filteredTransactions = transactionsList.filter((tx) =>
    statusFilter === "ALL"
      ? true
      : tx.payment_status.toUpperCase() === statusFilter
  );

  const sortedTransactions = [...filteredTransactions].sort((a, b) => {
    switch (sortBy) {
      case "DATE_ASC":
        return new Date(a.created_at) - new Date(b.created_at);
      case "DATE_DESC":
        return new Date(b.created_at) - new Date(a.created_at);
      case "AMOUNT_ASC":
        return a.amount_gross - b.amount_gross;
      case "AMOUNT_DESC":
        return b.amount_gross - a.amount_gross;
      case "STATUS_ASC":
        return a.payment_status.localeCompare(b.payment_status);
      case "STATUS_DESC":
        return b.payment_status.localeCompare(a.payment_status);
      default:
        return 0;
    }
  });

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentTransactions = sortedTransactions.slice(
    indexOfFirstItem,
    indexOfLastItem
  );
  const totalPages = Math.ceil(sortedTransactions.length / itemsPerPage);

  return (
    <div className="view">
      <Header />
      {account_type === "customer" ? (
        <SideNavCust collapsed={collapsed} onToggle={handleToggle} />
      ) : (
        <SideNav collapsed={collapsed} onToggle={handleToggle} />
      )}

      <div
        className="main-content events-dashboard"
        style={{
          marginTop: 60,
          marginLeft: isMob ? "0px" : collapsed ? "60px" : "240px",
        }}
      >
        {isMobile && !collapsed && (
          <div className="mobile-overlay active" onClick={handleToggle} />
        )}
        {isMob && collapsed && (
          <label className="mobile-toggle" onClick={handleToggle}>
            <BiMenu size={25} />
          </label>
        )}

        <div className="dashboard-header d-flext">
          <h5 className="dashboard-title mt-2">Transactions</h5>
          <span
            className="float-right cursor-pointer"
            onClick={() => history.goBack()}
          >
            <BiChevronLeft size={25} /> Back
          </span>
        </div>

        <div className="summary-grid">
          <SummaryCard
            title="Completed"
            count={formatToZAR(completeTransact) ?? 0.0}
            icon={
              <label className="event-icons-past event-icons d-none d-sm-block">
                <BiCheckCircle />
              </label>
            }
          />
          <SummaryCard
            title="Pending"
            count={formatToZAR(pendingTransact) ?? 0.0}
            icon={
              <label className="event-icons-ongoing event-icons d-none d-sm-block">
                <IoMdHourglass />
              </label>
            }
          />
          <SummaryCard
            title="Cancelled"
            count={formatToZAR(cancelledTransact) ?? 0.0}
            icon={
              <label className="event-icons-past event-icons d-none d-sm-block">
                <FcCancel />
              </label>
            }
          />

          <SummaryCard
            title="Abandoned"
            count={formatToZAR(abandonedTransact) ?? 0.0}
            icon={
              <label className="event-icons-abandoned event-icons d-none d-sm-block">
                <BiGhost />
              </label>
            }
          />

          <SummaryCard
            title="Refunds"
            count={formatToZAR(refundedAmt) ?? 0.0}
            icon={
              <label className="event-icons-refunds event-icons d-none d-sm-block">
                <BiMoney />
              </label>
            }
          />
        </div>

        <div className="filter-sort-controls">
          <div className="filter-sort-right">
            <div className="filter-group">
              <label>Status:</label>
              <select
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
              >
                <option value="ALL">All</option>
                <option value="PENDING">Pending</option>
                <option value="COMPLETE">Complete</option>
                <option value="CANCELLED">Cancelled</option>
                <option value="ABANDONED">Abandoned</option>
              </select>
            </div>

            <div className="sort-group">
              <label>Sort by:</label>
              <select
                value={sortBy}
                onChange={(e) => setSortBy(e.target.value)}
              >
                <option value="DATE_DESC">Date (Newest)</option>
                <option value="DATE_ASC">Date (Oldest)</option>
                <option value="AMOUNT_DESC">Amount (High → Low)</option>
                <option value="AMOUNT_ASC">Amount (Low → High)</option>
                <option value="STATUS_ASC">Status (A → Z)</option>
                <option value="STATUS_DESC">Status (Z → A)</option>
              </select>
            </div>
          </div>
        </div>

        <div className="table-container">
          <table className="events-table">
            <thead>
              <tr>
                <th>TransactID</th>
                <th>Date</th>
                <th>Event</th>
                <th className={account_type === "customer" ? "d-none" : ""}>
                  Buyer
                </th>
                <th>Type</th>
                <th>Admission</th>
                <th>Amt</th>
                <th>Status</th>
                <th>Refund Status</th>
                <th>Refund</th>
                <th className={account_type !== "customer" ? "d-none" : ""}>
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              <tr className={!loader ? "d-none" : ""}>
                <td colSpan={10}>
                  <div className="w-100 text-center p-3">
                    <ClipLoader
                      color={"grey"}
                      loading={true}
                      // css={override}
                      size={20}
                    />
                  </div>
                </td>
              </tr>

              {currentTransactions.length === 0 ? (
                <tr className={loader ? "d-none" : ""}>
                  <td
                    colSpan={account_type === "customer" ? 11 : 10}
                    style={{ textAlign: "center", padding: "20px" }}
                  >
                    No transactions found
                  </td>
                </tr>
              ) : (
                currentTransactions.map((transact, index) => (
                  <EventRow
                    key={index}
                    transact={transact}
                    account_type={account_type}
                    handleResend={handleResend}
                    resendingId={resendingId}
                  />
                ))
              )}
            </tbody>
          </table>

          {transactionsList.length > itemsPerPage && (
            <div className="pagination-controls">
              <button
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
              >
                Previous
              </button>
              <span>
                Page {currentPage} of {totalPages}
              </span>
              <button
                onClick={() =>
                  setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                }
                disabled={currentPage === totalPages}
              >
                Next
              </button>
            </div>
          )}
        </div>
      </div>

      {resendStatus && (
        <div className={`resend-toast ${resendStatus}`}>{resendReponse}</div>
      )}
    </div>
  );
};

export default TransactionsCust;
